export default __webpack_public_path__ + "static/media/1.1.4.ee9eaf0e.png";